import { frontendURL } from '../../../helper/URLHelper';
import B2bIndex from './pages/B2bIndex.vue';
import B2bDetail from './pages/B2bDetail.vue';
import ProductCenterIndex from './pages/ProductCenterIndex.vue';
import ProductForm from './pages/ProductForm.vue';
import CollectionsIndex from './pages/CollectionsIndex.vue';
import CollectionForm from './pages/CollectionForm.vue';
import MediaCenterIndex from './pages/MediaCenterIndex.vue';
import IntegrationsIndex from './pages/IntegrationsIndex.vue';
import B2bOrdersIndex from './pages/B2bOrdersIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/b2b'),
    name: 'b2b_index',
    component: B2bIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/urun-merkezi'),
    name: 'product_center_index',
    component: ProductCenterIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/urun-merkezi/yeni'),
    name: 'product_new',
    component: ProductForm,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/urun-merkezi/:id/duzenle'),
    name: 'product_edit',
    component: ProductForm,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/medya-merkezi'),
    name: 'media_center_index',
    component: MediaCenterIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/toptan-siparisler'),
    name: 'b2b_orders_index',
    component: B2bOrdersIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/entegrasyonlar'),
    name: 'integrations_index',
    component: IntegrationsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/koleksiyonlar'),
    name: 'collections_index',
    component: CollectionsIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/koleksiyonlar/yeni'),
    name: 'collection_new',
    component: CollectionForm,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/koleksiyonlar/:id/duzenle'),
    name: 'collection_edit',
    component: CollectionForm,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/b2b/:productId'),
    name: 'b2b_detail',
    component: B2bDetail,
    meta: commonMeta,
  },
];
